import Profile from './Profile';

export const profileRoutes = [{path: '/profile', name: 'Profile', Component: Profile}];
